/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React, { useState, useEffect, Fragment, useRef } from 'react';
import { connect } from 'react-redux'
import { AUTH_CONFIG } from '../../../../Auth/auth0-variables';
import axios from 'axios';
import {
    Spinner, SpinnerSize, DefaultButton, TextField, ProgressIndicator, IconButton, NormalPeoplePicker, PrimaryButton, Checkbox
} from '@fluentui/react';

import { shallowEqual, useSelector } from 'react-redux';
import uploadFileToBlob from '../../../../HelperComponents/azureBlob';
import Editor from '../../../../UiKit/SharedComponents/Editor';
import PeopleSelectWithGroups from '../../../../UiKit/SharedComponents/PeopleSelectWithGroups';

const but = css`
    .continue{
        border-radius: 5px;
        background-color: #f8f8f8;
    }
`;

const editor = css`
    border: 1px solid rgba(var(--palette-neutral-20, 200, 200, 200), 1);
    border-radius: 4px;
    overflow:hidden;
`;

const progressCss = css`
   .ms-ProgressIndicator-itemProgress {
        height: 8px;
        padding:0;
        transition: width 0.55s linear 0s;
        .ms-ProgressIndicator-progressTrack {
            height: 8px;
            border-radius: 10px;
        }
        .ms-ProgressIndicator-progressBar {
            height: 8px;
            border-bottom-left-radius: 5px;
            border-top-left-radius: 5px;
        }
}
    `;

const pickerContainer = css`
    height: 80vh;
    margin-left: -10px;
`;

function CreateAnnouncement(props) {
    const [toList, setToList] = React.useState([]);
    const [title, setTitle] = React.useState('');
    const [description, setDescription] = React.useState('');
    const [attachments, setAttachments] = React.useState([]);
    const [creating, setCreating] = React.useState(false);
    const [required, setRequired] = React.useState(false);
    const [editorState, setEditorState] = useState("");
    const [step, setStep] = React.useState(1);


    const { clientID, facilityId } = useSelector(state => ({
        facilityId: state.appState.product.facility.facilityID,
        clientID: state.appState.clientID
    }));

    const elementRef = useRef();


    // UI/form management
    const [uploading, setUploading] = useState(false);

    const getUniqueFileName = (originalName, shortId) => {
        const dotIndex = originalName.lastIndexOf(".");
        if (dotIndex === -1) return `${originalName}_${shortId}`; // no extension fallback

        const name = originalName.slice(0, dotIndex).replace(/\s+/g, '_');
        const ext = originalName.slice(dotIndex);
        return `${name}_${shortId}${ext}`;
    };


    const onFileChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const shortId = Math.random().toString(36).substring(2, 6);
        const uniqueFileName = getUniqueFileName(file.name, shortId);

        setAttachments(prev => [...prev, uniqueFileName]);

        const renamedFile = new File([file], uniqueFileName, { type: file.type });

        await uploadFileToBlob(renamedFile, `files/clients/${clientID}`);
    };


    const onFileUpload = async () => {
        elementRef.current.click()
    };

    const create = () => {
        if (creating) {
            return;
        }

        setCreating(true);
        var model = {
            to: toList.map(x => x.userId),
            title: title,
            required:required,
            description: description,
            attachments: attachments,
            facilityId: facilityId
        }
        axios.post(AUTH_CONFIG.API_URL + "/api/Schedules/CreateAnnouncement", model)
            .then((response) => {
                props.callback(response.data)
            });
    }

    const updateCallback = (data) => {
        setDescription(data);
    }

    const setSelected = (items) => {
        setToList(items)
    }

    return (
        <div className="chat-list">

            <div className="displayflex flexcolumn width100" style={{ padding: '10px 20px 10px 0' }} >
               
                <div className=" displayflex spacebetween" css={progressCss}>
                    <div className="width100">
                        <ProgressIndicator percentComplete={(step * 2) / 10} />
                        <p className="step-p mt5 mb15 text-dark-to-light">Step {step} of 2</p>
                    </div>
                </div>
                {step === 1 && <>
                    <label class="control-label">Subject</label>
                    <TextField value={title} styles={{ fieldGroup: { height: '38px' }, field: { height: '38px' } }} placeholder="Add subject" className="width100 mb10" onChange={(event) => setTitle(event.target.value)} />
                    <label class="control-label">Announcement</label>
                    <div css={editor}><Editor updateCallback={updateCallback} data={editorState} /></div>
                    <div className="mt20 mb5">
                        <Checkbox style={{ fontWeight: '400' }} checked={required} label="Require staff to review" onChange={(ev, isChecked) => setRequired(isChecked)} />
                    </div>

                    {attachments.length > 0 && !uploading && attachments.map((a, i) => {
                        return <div className="attachment-pill mt10">
                            <i class="ms-Icon ms-Icon--TextDocument"></i>
                            <span className="name">{a}</span>
                            <IconButton
                                styles={{
                                    root: {
                                        marginLeft: 'auto',
                                        marginRight: '2px',
                                    },
                                    icon: { fontSize: 14 },
                                    rootHovered: {
                                        color: "black",
                                        backgroundColor: 'transparent'
                                    },
                                    rootPressed: {
                                        color: "black",
                                        backgroundColor: 'transparent'
                                    },
                                }}
                                iconProps={{ iconName: 'ChromeClose' }}
                                onClick={() => setAttachments(attachments.filter(item => item !== a))}
                            />
                        </div>
                    })}
                    <div className="displayflex mt10">
                        <input type="file" ref={elementRef} onChange={onFileChange} style={{ display: 'none' }} />
                        <DefaultButton
                            className="btn-secondary"
                            text={'Attach'}
                            iconProps={{ iconName: 'Attach' }}
                            onClick={onFileUpload}
                            disabled={uploading}
                        />
                        {uploading &&
                            <Spinner size={SpinnerSize.small} />
                        }
                    </div>
                    <div className="displayflex justifyflexend aligncenter" css={but}>
                        <PrimaryButton
                            disabled={!title}
                            text={"Next"}
                            onClick={() => { setStep(2); }} />
                    </div>
                    <style>
                        {`
                        #EditorContainer{
                            height:350px !important;
                        }
                        ` }
                    </style>
                </>}
                {step === 2 && <>
                    <div className="flexcolumn mb10 flex1 ml5 pl20" css={pickerContainer}>
                        <h3 className="head-s ">Choose Groups</h3>
                        <PeopleSelectWithGroups height="calc(-450px + 100vh)" maxHeight="calc(80vh - 250px)" callback={setSelected} selected={toList.map(x => x.userId)} />
                    </div>
                    <div className="displayflex justifyflexend aligncenter mt20" css={but}>
                        <DefaultButton
                            text={"Back"}
                            onClick={() => setStep(1)}
                            style={{ width: 85 }}
                            className=" mr10" />
                        <PrimaryButton
                            disabled={creating} // Disable the button while updating
                            onClick={() => { create(); setCreating(true); }}
                            style={{ width: 85 }}
                        >
                            {creating ? (
                                <Spinner size={SpinnerSize.small} /> // Add a spinner inside the button
                            ) : ("Create")}
                        </PrimaryButton>
                    </div>
                </>}
            </div>
           


        </div>
    );
}

export default CreateAnnouncement;

